import { CodeCodeUsageCount } from "@modules/Coupon/components/CouponCodesField";

class CouponUtils {
    public static getUsedCodesCount = (codes: CodeCodeUsageCount[] | null, maxUsageCount: number): number | null => {
        if (!codes) {
            return 0;
        }

        const usageCounts: Array<number | null> = codes.map((code: CodeCodeUsageCount) => code.usage_count);
        return usageCounts.reduce<number>((accumulator, count) => accumulator + maxUsageCount - (count || 0), 0);
    }
}

export default CouponUtils;


// WEBPACK FOOTER //
// ./src/utils/CouponUtils.ts